<template>
  <b-container fluid class="p-0">
    <b-row>
      <b-col sm="12" lg="9" xl="7">
        <b-card no-body>
          <b-card-header header-class="dark-header">
            <span class="font-weight-bold text-white">MENUPOLY Utility App</span>
          </b-card-header>
          <b-card-body class="p-4">
            <div class="d-flex align-items-start">
              <p class="intro mb-0 flex-grow-1">
                The MENUPOLY Utility App is for businesses that use MENUPOLY ordering services. It runs in
                the background on Android devices, such as your KDS, POS terminal display, or self-ordering
                kiosk, and manages order ticket printers, customer receipt printers, kitchen display order
                notifications, and clock in/out terminal registration and verification.
              </p>
              <img src="../../../public/img/menupoly-utility-icon.png" alt="MENUPOLY Utility App"
                   class="app-icon ml-4 d-none d-sm-block"/>
            </div>

            <div class="text-center my-4">
              <b-button :href="downloadUrl" variant="light" size="lg" class="download-btn" download>
                <font-awesome-icon icon="download" class="mr-2"/>
                Download MENUPOLY Utility App (APK)
              </b-button>
              <div class="small text-muted mt-2">For Android devices only</div>
            </div>

            <h5 class="font-weight-bold mb-4">How to install the MENUPOLY Utility App</h5>

            <ol class="install-steps">
              <li v-for="(step, index) in steps" :key="index">
                <span class="step-number">{{ index + 1 }}</span>
                <span class="step-text" v-html="step"></span>
              </li>
            </ol>

            <div class="credentials-note d-flex align-items-start mt-4">
              <font-awesome-icon icon="info-circle" class="note-icon mr-3 mt-1"/>
              <span>
                <strong>Use utility app credentials only.</strong>
                Standard MENUPOLY user logins will not work in this app.
              </span>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: 'downloads',
  metaInfo() {
    return {
      title: 'Downloads'
    }
  },
  data() {
    return {
      downloadUrl: 'https://www.menupoly.com/app/utility.apk',
      steps: [
        'If an older version of the app is installed on your Android device, <strong>uninstall it first</strong>.',
        'On the Android device where you want to install the app, open this page and tap the <strong>Download MENUPOLY Utility App</strong> button above.',
        'If prompted about downloading from unknown sources, <strong>allow the download</strong>.',
        'Open the device\'s <strong>Downloads</strong> folder and tap the APK file to install it.',
        'If prompted about installing from unknown sources, <strong>allow the installation</strong>.',
        'Once installed, open the <strong>MENUPOLY Utility App</strong> from the device\'s Apps list.',
        'When asked to allow the app to run in the background, tap <strong>Allow</strong>.',
        'Log in with the utility app username and password provided to you.'
      ]
    }
  }
}
</script>

<style scoped>
.intro {
  line-height: 1.7;
  color: #3c4b54;
}

.app-icon {
  width: 96px;
  height: auto;
  flex-shrink: 0;
}

.download-btn {
  background: #d5dbdf;
  border-color: #d5dbdf;
  color: #3c4b54;
  font-size: 1rem;
  padding: 0.6rem 1.5rem;
}

.download-btn:hover {
  background: #c5ccd1;
  border-color: #c5ccd1;
  color: #23282c;
}

.install-steps {
  list-style: none;
  padding: 0;
  margin: 0;
  position: relative;
}

.install-steps li {
  display: flex;
  align-items: flex-start;
  position: relative;
  padding-bottom: 1.1rem;
}

.install-steps li:last-child {
  padding-bottom: 0;
}

.install-steps li:not(:last-child)::before {
  content: '';
  position: absolute;
  left: 13px;
  top: 28px;
  bottom: 0;
  width: 2px;
  background: #dfe3e6;
}

.step-number {
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #455a64;
  color: #fff;
  font-size: 0.85rem;
  font-weight: bold;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 1.25rem;
  position: relative;
  z-index: 1;
}

.step-text {
  padding-top: 3px;
  color: #3c4b54;
}

.credentials-note {
  max-width: 560px;
  background: #fff4e8;
  border: 1px solid #f9c99a;
  border-radius: 4px;
  padding: 0.9rem 1rem;
  color: #3c4b54;
}

.note-icon {
  color: #f37021;
  flex-shrink: 0;
}
</style>
